import * as React from 'react';
import icon from '../../assets/img/flags/texas.svg';

export const Texas = (props) => <img src={icon} height={props.height || 100} alt="Flag" />;
